// src/components/routing/RoleBasedIndex.tsx
import { Navigate } from 'react-router-dom';
import { getDefaultRoute } from 'src/lib/utils';

const IndexRoute = ({ routes }: { routes: any }) => {
    const defaultPath = getDefaultRoute(routes);    
    return <Navigate to={defaultPath} replace />;
};

export default IndexRoute